import { Icon } from '@ets/design-system';
import cx from 'classnames';
import styles from './ThumbnailCards.module.scss';

type ThumbnailCardsProps = {
  comments?: number;
  tasks?: number;
  notes?: boolean;
};

const ThumbnailCards = ({ comments, tasks, notes }: ThumbnailCardsProps) => {
  return (
    <>
      <div className={styles.bottomWrapper} data-testid="thumbnail-cards">
        {comments ? (
          <div className={styles.element} data-testid="thumbnail-comments">
            <Icon size="2" icon="comment" testId="comments" color="neutral" />
            <span data-testid="thumbnail-comments-count">{comments > 9 ? '9+' : comments}</span>
          </div>
        ) : null}
        {tasks ? (
          <div className={styles.element} data-testid="thumbnail-tasks">
            <Icon size="2" icon="circle-check" testId="tasks" color="neutral" />
            <span data-testid="thumbnail-tasks-count">{tasks > 9 ? '9+' : tasks}</span>
          </div>
        ) : null}
      </div>

      {notes ? (
        <div className={cx(styles.element, styles.note)} data-testid="thumbnail-notes">
          <Icon size="2" icon="sticky-note" testId="notes" color="neutral" />
        </div>
      ) : null}
    </>
  );
};

export default ThumbnailCards;
